import React, { useState, useEffect, useRef } from "react";
import Pagination from "../../shared/common/pagination";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import { FilterIcon, ResetIcon, CSVIcon } from "../../../assets/icons/index";
import ExportToCSV from "../../shared/common/exportToCsv";

const activities = [
  {
    activityId: 1,
    name: "Subjects",
    activityType: "Edit",
    userName: "Admin J",
    date: "21-Dec-2022",
  },
  {
    activityId: 2,
    name: "Questions",
    activityType: "Edit",
    userName: "Authour 1",
    date: "21-Jul-2022",
  },
  {
    activityId: 3,
    name: "Standards",
    activityType: "Delete",
    userName: "Authour 2",
    date: "21-Jul-2022",
  },
];

const ActivityReport: React.FC = () => {
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const initialState = {
    gradeId: 0,
    name: "",
    abbreviation: "",
  };
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalPages, setTotalPages] = useState(2);
  const [totalRecords, setTotalRecords] = useState<number>(25);
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const childRef: any = useRef(undefined);

  return (
    <div className="flex-1 overflow-auto">
      <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
        <div className="relative  py-1">
          <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>

          <form action="#">
            <div className="pt-6 border-b pb-6">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-3 sm:col-span-3 ">
                  <label className="text-sm text-gray-700">Activity Name</label>
                  <div className="contentArea">
                    <input
                      id="activityId"
                      name="activityId"
                      type="text"
                      autoComplete="off"
                      className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>

                <div className="col-span-3 sm:col-span-3 ">
                  <label className="text-sm text-gray-700">Activity Type</label>
                  <div className="contentArea">
                    <input
                      id="activityType"
                      name="activityType"
                      type="text"
                      autoComplete="off"
                      className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>
                <div className="col-span-3 sm:col-span-3">
                  <label className="text-sm text-gray-700">User</label>
                  <div className="contentArea">
                    <input
                      id="User"
                      name="User"
                      type="text"
                      autoComplete="off"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-start">
                <button
                  type="submit"
                  className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                >
                  <FilterIcon className="w-3 h-3"></FilterIcon>
                  <span>Filter</span>
                </button>
                <button
                  type="button"
                  className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <ResetIcon className="w-3 h-3"></ResetIcon>
                  <span>Reset Filter</span>
                </button>
              </div>
            </div>
            <div className="flex justify-end">
              <button
                type="button"
                className="mt-4 py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
              >
                <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                <span>Export</span>
              </button>
              <ExportToCSV ref={childRef} />
            </div>
          </form>

          <div id="dataContainer" className="mt-4">
            <div className="flex flex-col mt-1">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-primary-color">
                        <tr>
                          <th
                            scope="col"
                            className="inline-flex items-center gap-2 px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                          >
                            <span className="flex">ID</span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                          >
                            <span className="flex">Activity Name</span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                          >
                            <span className="flex">Activity Type</span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                          >
                            <span className="flex">Date</span>
                          </th>

                          <th
                            scope="col"
                            className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                          >
                            <span className="flex">User</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {activities.map((activity, index) => (
                          <tr
                            key={activity.activityId}
                            className={
                              index % 2 === 0 ? "bg-white" : "bg-gray-100"
                            }
                          >
                            <td className="px-3 py-2 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline">
                              {activity.activityId}
                            </td>
                            <td className="px-3 py-2 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline">
                              {activity.name}
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                              <p>{activity.activityType}</p>
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                              {activity.date}
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                              {activity.userName}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                className={`flex justify-between items-center ${
                  activities.length === 0 ? "hidden" : ""
                }`}
              >
                <Pagination
                  pages={totalPages}
                  setPageNumber={setPageNumber}
                  ref={paginationRef}
                />
                <span>
                  <span className="text-sm pr-4 ml-auto text-left-700">
                    Showing {pageNumber} to{" "}
                    {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                    {totalRecords} results
                  </span>

                  <SelectPageSize
                    setPageSize={setPageSize}
                    type={"second"}
                    ref={pageSizeRef}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityReport;
